import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class DataDeliveryService {

  public pedido_id ='';
  public forma_entrega = 0;
  public direccion = '';
  public observaciones_delevery ='';
  public latitud = 0;       // ok
  public longitud = 0;      // ok
  public id_provincia = 0;  // ok
  public provincia = '';    // ok
  public id_distrito = 0;   // ok
  public distrito = '';     // ok
  public id_correguimiento = 0;
  public correguimiento = '';
  public id_barrio = 0;
  public barrio = '';
  public cedulaCliente = '';
  public nombre = '';
  public apellido = '';
  public celular = '';
  public email = '';
  public calle = '';
  public casa_apto = '';
 
  public urlBase = environment.urlBase;  

  constructor(private http: HttpClient) { }

  guardarDataDelivery(){

    let params = this.objFormaEntrega();

    const headers = new HttpHeaders ({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic c2lsaWNlcG9zOm1ZUFJ2dVAw'
    });
    //console.log(params);
   //return this.http.post('https://api-test.smallshi.com/pedido/updateFormaEntregaPedido',this.ObjecttoParams(params), {headers}) 
    return this.http.post(this.urlBase + 'pedido/updateFormaEntregaPedido',params, {headers});
  }

  objFormaEntrega(){
    
    let params ={
      'pedido_id': this.pedido_id,
      'forma_entrega': this.forma_entrega,
      'direccion': this.direccion,
      'observaciones_delevery': this.observaciones_delevery,
      'latitud': this.latitud,
      'longitud': this.longitud,
      'id_provincia': this.id_provincia,
      'provincia': this.provincia,
      'id_distrito': this.id_distrito,
      'distrito': this.distrito,
      'id_correguimiento': this.id_correguimiento,
      'correguimiento': this.correguimiento,
      'id_barrio': this.id_barrio,
      'barrio': this.barrio,
      'cedulaCliente': this.cedulaCliente,
      'nombre': this.nombre,
      'apellido': this.apellido,
      'celular': this.celular,
      'email':  this.email,
      'calle': this.calle,
      'casa_apto': this.casa_apto
    };
    return this.ObjecttoParams(params);
    //return JSON.stringify(params);
    
  }
  ObjecttoParams(obj) {
    var p = [];
      for (var key in obj) {
      p.push(key + '=' + encodeURIComponent(obj[key]));
      } 
      return p.join('&'); 
    }
}
